/** Store listing price display helpers (price-slash tiers + currency formatting). */

export const formatCurrency = (value: number): string => {
    const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);

    // Strips only the first '.00' occurrence (not a trailing-only replace).
    return formatted.replace('.00', '');
};

/**
 * Numeric amount the store card charges when price slash is on or off.
 * Shared with the schema and with the server filter contract (`store-price-cases.json`).
 * Tiers use strict greater-than, matching the card:
 * - over $400 → −$20
 * - over $300 → −$15
 * - over $200 → −$10
 * - else → 5% off, rounded to nearest dollar
 */
export const getEffectiveStorePrice = (price: number, priceSlashActive: boolean): number => {
    if (!priceSlashActive) return price;

    if (price > 400) return price - 20;
    if (price > 300) return price - 15;
    if (price > 200) return price - 10;
    return Math.round(price - price * 0.05);
};

/** Same amount as `getEffectiveStorePrice`, formatted the way the card prints it. */
export const getDiscountedPrice = (price: number, priceSlashActive: boolean): string => formatCurrency(getEffectiveStorePrice(price, priceSlashActive));
